import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RequestControllerv2Service } from '@app/generated-api';
import { LabeledTextComponent } from '@app/v2/components/labeled-text/labeled-text.component';
import { RequestType } from '@app/v2/enums/request-types.enum';
import { resolveRequestStatusName } from '@app/v2/utils/request-status.utils';
import { computedAllDefined } from '@app/v2/utils/signal-utils';
import {
    MdsButtonComponent,
    MdsDropdownComponent,
    MdsOption,
    MdsTextareaComponent,
} from '@medpacesoftwaredevelopment/designsystem';
import { TravelRequestStatus } from '@models/request';
import { TravelRequestStatusChangeFormGroup } from './travel-request-status-change-modal-content.form';

@Component({
    templateUrl: './travel-request-status-change-modal-content.component.html',
    selector: 'medpace-travel-request-status-change-modal-content',
    imports: [LabeledTextComponent, MdsDropdownComponent, MdsTextareaComponent, MdsButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TravelRequestStatusChangeModalContentComponent {
    generatedRequestService = inject(RequestControllerv2Service);

    formGroup = input.required<TravelRequestStatusChangeFormGroup>();
    requestId = input.required<number>();

    cancel = output<void>();
    confirm = output<TravelRequestStatusChangeFormGroup>();

    modalContentInitialValue: () => ModalContent = () => ({
        confirmButton: {
            onClick: () => {
                if (this.formGroup().invalid) {
                    this.formGroup().markAllAsTouched();
                    return;
                }

                this.confirm.emit(this.formGroup());
            },
        },
        cancelButton: {
            onClick: () => {
                this.cancel.emit();
            },
        },
    });
    modalContent = signal<ModalContent>(this.modalContentInitialValue());

    travelRequestDetails = rxResource({
        params: () => ({ requestId: this.requestId() }),
        stream: ({ params }) =>
            this.generatedRequestService.requestControllerv2GetTravelRequestDetails(params.requestId),
    });
    travelRequestDetails_CurrentStatusId = computedAllDefined(
        { travelRequestDetails: this.travelRequestDetails.value },
        ({ travelRequestDetails }) => travelRequestDetails.statusId as TravelRequestStatus
    );
    currentStatus = computedAllDefined(
        { currentStatusId: this.travelRequestDetails_CurrentStatusId },
        ({ currentStatusId }) => resolveRequestStatusName(RequestType.Travel, currentStatusId, false)
    );

    options = computedAllDefined(
        {
            travelRequestDetails: this.travelRequestDetails.value,
        },
        ({ travelRequestDetails }) => {
            return travelRequestDetails.availableStatuses.map((status) => {
                return <MdsOption<TravelRequestStatus>>{
                    value: status.id as TravelRequestStatus,
                    viewValue: resolveRequestStatusName(RequestType.Travel, status.id, false),
                };
            });
        }
    );
}
export type ModalContent = {
    confirmButton: { onClick: () => void };
    cancelButton: { onClick: () => void };
};
